export default [
  { key: 'monday', value: 'Segunda-Feira' },
  { key: 'tuesday', value: 'Terça-Feira' },
  { key: 'wednesday', value: 'Quarta-Feira' },
  { key: 'thursday', value: 'Quinta-Feira' },
  { key: 'friday', value: 'Sexta-Feira' },
  { key: 'saturday', value: 'Sábado' },
  { key: 'sunday', value: 'Domingo' },
];
